import {motion} from 'framer-motion'
import {Ripple} from 'primereact/ripple'
import React from 'react'
import {getLanguageCode} from '../../i18n/LanguageUtils'
import {
    hideOverlayTooltip,
    showOverlayTooltip,
} from '../overlay-tooltip/OverlayTooltipService'

const StyledToolbarIcon = ({
    icon,
    disable = false,
    label,
    description = 'description',
    onClick = () => {},
    onDisabledClick = () => {},
}) => {
    const currentLanguage = getLanguageCode()

    return (
        <React.Fragment>
            <motion.div
                className={`styled-toolbar-icon-wrapper border-round-lg  ${
                    disable && 'opacity-70'
                } px-2 py-2 text-center ${
                    currentLanguage === 'bg' && 'bg-width'
                } ${
                    !disable ? 'cursor-pointer' : 'cursor-not-allowed disable'
                } relative`}
                whileTap={{scale: 0.97}}
                onClick={() => {
                    if (!disable) {
                        onClick()
                    } else {
                        onDisabledClick()
                    }
                }}
                onMouseEnter={e => {
                    showOverlayTooltip(
                        e,
                        <div>
                            <h6
                                className="toolbar-tooltip m-0 font-semibold"
                                style={{color: 'darkcyan'}}>
                                {label}
                            </h6>{' '}
                            <p>{description}</p>
                        </div>,
                        'right',
                    )
                }}
                onMouseLeave={e => {
                    hideOverlayTooltip(e)
                }}>
                <div className={` ${!disable ? '' : ''} toolbar-icon  h-2rem`}>
                    {' '}
                    {icon}
                </div>

                <div className="toolbar-label">
                    <h6
                        className={`${
                            !disable ? 'text-700' : 'text-400'
                        } m-0 p-0 text-600 text-sm`}>
                        {label}
                    </h6>
                </div>

                <Ripple />
            </motion.div>
            <div
                className={`${
                    disable && 'opacity-60'
                } styled-toolbar-wrapper gap-3 p-2 hover:bg-gray-50 cursor-pointer border-round-sm pl-0`}
                onClick={() => {
                    if (!disable) {
                        onClick()
                    } else {
                        onDisabledClick()
                    }
                }}>
                <div className="toolbar-toggle-icon text-blue-700"> {icon}</div>
                <div>
                    <h6 className="m-0 p-0 mb-1 font-bold">{label}</h6>
                    <p>{description}</p>
                </div>
            </div>
        </React.Fragment>
    )
}

export default StyledToolbarIcon
